












import Vue from "vue";
import TheNavbar from "@/components/TheNavbar.vue";
import TheHeader from "@/components/TheHeader.vue";
export default Vue.extend({
  name: "App",
  components: { TheNavbar, TheHeader },
  data: () => {
    return {
      drawer: null,
    };
  },
  mounted() {
    const hash: string = this.$route.hash;
    if (hash.startsWith("#confirmation_token=")) {
      console.log("confirming...");
      window.location.hash = "";
      this.$auth
        .confirm(hash.split("=")[1], true)
        .then((responseUser) => {
          console.log(responseUser);
          this.$user = responseUser;
        })
        .catch((error) => {
          console.error(error);
        });
    }
  },
  computed: {
    sysMessage(): string {
      let msg = "";
      if (this.$user && !this.$userConfirmed) {
        msg =
          "Your mail is not yet confirmed. You may start using the site now, but please be aware that you will NOT be able to log in again until you verify your e-mail!";
      }
      return msg;
    },
  },
});
